import React, {Component} from 'react';

export default class About extends Component {
    render() {
        return (
            <div>
                <h2>Quand l'enthousiasme compte plus que le profit</h2>
                <div>
                    <p>
                        Entrepreneurs de la net-économie, les associés qui portent le projet Fundovino ont chacun leur spécialité : gestion, développement, marketing, communication.
                        < br/>Mais ensemble, ils ont en commun d'aimer le vin et les idées neuves.
                        < br/>C'est pour cette passion qu'ils se sont retrouvés autour du projet Fundovino, premier site de financement participatif dédié au monde du vin.
                    </p>
                    <p>
                        <strong>Le projet Fundovino est unique :</strong>
                        < br/>< br/>
                        <ul>
                            <li>Il s'inscrit dans le respect de la vigne mais aussi des hommes qui l'élèvent, la bonifient et la travaillent pour l'offrir aux palais des autres.</li>
                            <li>Il participe d'une « éthique de l'étiquette ».</li>
                        </ul>
                        En effet, l'engagement est mutuel :
                        < br/>< br/>
                        <ul>
                            <li>Pour le porteur de projet, respecter une « charte de bonne intelligence » qui tourne autour de mots-clés essentiels : la qualité, l'élégance, le respect de la nature et du sol, l'envie d'œuvrer pour que le vin continue de se bonifier.</li>
                            <li>Pour l'investisseur ou le donateur potentiel, être partie prenante, de l'intérieur, d'un projet qui le fasse rêver, le séduise, le transporte ou tout simplement l'intéresse…</li>
                        </ul>
                    </p>
                    <p>
                        Fundovino est un espace d'échanges avec d'un côté, celui des innovateurs pour promouvoir un projet qui casse les codes ou éclaire une part d'avenir,
                        et de l'autre, l'envie des donateurs de découvrir, de participer au défrichage de nouveaux territoires, et pourquoi pas de laisser une empreinte,
                        < br/>En fait, sur Fundovino, votre enthousiasme pour le vin compte plus que le profit.
                    </p>
                </div>
            </div>
        );
    }
}
